export const removeDuplicatedArray = (data, key) => {
  const seen = new Set();
  return Array.isArray(data) && data?.filter((v) => {
    if (seen.has(v[key])) {
      return false;
    }
    seen.add(v[key]);
    return true;
  }) || [];
}

export const reduceArrayObjects = (data, arrayToCreate = "projects", key = "name") => {
  let resultFilterProjects = []
  if (data.length > 0) {
    resultFilterProjects = Object.values(
      data.reduce((acc, el) => {
        acc[el[key]] = acc[el[key]] || { [arrayToCreate]: [] }
        acc[el[key]][arrayToCreate].push(el[arrayToCreate])
        return acc
      }, []),
    )
  }
  return resultFilterProjects.flatMap((item) => item[arrayToCreate][0])
}